import { BinaryWriter } from "../binary.js";
import { ClientOp, ServerOp } from "../opcodes.js";
/** Alcance da fala local, em tiles. Menor que a Área de Interesse de propósito. */
export const CHAT_RANGE = 10;
/** Teto de caracteres aceitos numa fala. */
export const MAX_CHAT_LENGTH = 160;
/**
 * Canais de fala (PRD §6).
 *
 * A divisão que importa não é temática, é **de rota**: `Local` nunca sai do worker da
 * região, porque ele é o único que sabe quem está perto de quem; todos os outros precisam
 * atravessar instâncias, e por isso passam pelo gateway e pelo barramento Redis (§3.3).
 * Tratar os dois casos pelo mesmo caminho obrigaria o worker a conhecer o mundo inteiro,
 * que é justamente o que o isolamento por região existe para impedir.
 */
export const ChatChannel = {
    /** Balão sobre o personagem, dentro de `CHAT_RANGE`. Não sai da região. */
    Local: 0,
    /** Canal global do mundo. Atravessa regiões e instâncias. */
    World: 1,
    /** Canal global de comércio. Separado do mundo porque o assunto é outro — e porque
     *  misturá-los faz uma das duas conversas expulsar a outra da tela. */
    Trade: 2,
    /** Só os membros da guilda. */
    Guild: 3,
    /** Mensagem privada. `to` diz para quem. */
    Private: 4,
};
export function isChatChannel(value) {
    return value >= 0 && value <= 4;
}
export const CHANNEL_NAMES = {
    [ChatChannel.Local]: 'Local',
    [ChatChannel.World]: 'Mundo',
    [ChatChannel.Trade]: 'Comércio',
    [ChatChannel.Guild]: 'Guilda',
    [ChatChannel.Private]: 'Privado',
};
export function encodeChat(packet, writer = new BinaryWriter(192)) {
    writer.u8(ClientOp.Chat).u8(packet.channel).str8(packet.to).str8(packet.text);
    return writer;
}
export function decodeChat(reader) {
    const rawChannel = reader.u8();
    return {
        channel: isChatChannel(rawChannel) ? rawChannel : ChatChannel.Local,
        to: reader.str8(),
        text: reader.str8(),
    };
}
export function encodeChatMessage(packet, writer = new BinaryWriter(256)) {
    writer
        .u8(ServerOp.Chat)
        .u8(packet.channel)
        .u32(packet.speakerId)
        .u16(packet.x)
        .u16(packet.y)
        .u8(packet.z)
        .str8(packet.name)
        .str8(packet.text);
    return writer;
}
export function decodeChatMessage(reader) {
    const rawChannel = reader.u8();
    return {
        channel: isChatChannel(rawChannel) ? rawChannel : ChatChannel.Local,
        speakerId: reader.u32(),
        x: reader.u16(),
        y: reader.u16(),
        z: reader.u8(),
        name: reader.str8(),
        text: reader.str8(),
    };
}
//# sourceMappingURL=chat.js.map